import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useMediaQuery } from "react-responsive"; // Importing useMediaQuery
import Header from "./components/Header/Header"; // Importing Header component
import MobileHeader from "./components/MobileHeader/MobileHeader"; // Importing MobileHeader component
import Home from "./pages/Home/Home"; // Importing Home page
import Register from "./pages/Register/Register"; // Importing Register page
import "./styles/global.css"; // Import global styles
import About from "./pages/About/About";
import Footer from "./components/Footer/Footer";
import Login from "./pages/Login/Login";
import DashboardPage from "./pages/Dashboard/DashboardPage";
import Post from "./pages/AddPost/Post";
import Blog from "./pages/AddBlog/Blog";
import BlogListing from "./pages/BlogListing/BlogListing";
import BlogView from "./pages/BlogView/BlogView";
import PostListing from "./pages/PostListing/PostListing";

const isAdmin = () => {
  const user = JSON.parse(localStorage.getItem("user")); // Get the user object from localStorage
  const token = localStorage.getItem("token"); // Get the token from localStorage

  return !(!token || !user || user.role !== "admin");
};

const App = () => {
  const isMobile = useMediaQuery({ maxWidth: 768 }); // Determine if the screen width is less than or equal to 768px

  return (
    <Router>
      {isMobile ? <MobileHeader /> : <Header />}{" "}
      {/* Conditionally render headers */}
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/register" element={<Register />} />
        <Route path="/login" element={<Login />} />
        <Route path="/about" element={<About />} />

        <Route path="/blogs" element={<BlogListing />} />
        <Route path="/blog/:id" element={<BlogView />} />
        <Route path="/posts" element={<PostListing />} />

        {/* Admin Only. */}
        <Route
          path="/add-post"
          element={isAdmin() ? <Post /> : <Navigate to="/" />}
        />
        <Route
          path="/edit-post/:postId"
          element={isAdmin() ? <Post /> : <Navigate to="/" />}
        />
        <Route
          path="/add-blog"
          element={isAdmin() ? <Blog /> : <Navigate to="/" />}
        />
        <Route
          path="/edit-blog/:blogId"
          element={isAdmin() ? <Blog /> : <Navigate to="/" />}
        />
        <Route
          path="/dashboard"
          element={isAdmin() ? <DashboardPage /> : <Navigate to="/" />}
        />
      </Routes>
      <Footer />
    </Router>
  );
};

export default App;
